<template>
  <v-img :src="image" @error="loadingError=true" v-if="!!image">
    <fin-logo-sign :dark="dark" loading size="100%" slot="placeholder"/>
  </v-img>
</template>

<script>
import finLogoSign from '@/components/common/logo/LogoSign'
import {mapState} from 'vuex'
import {API, graphqlOperation, Storage} from "@/plugins/finAmplifyModules"
import {updateUserProfileImage} from "@/js/finMutations"

export default {
  name: 'fin-profile-img',
  components: {finLogoSign},
  props: {
    dark: {
      type: Boolean
    }
  },
  data() {
    return {
      loadingError: false
    }
  },
  asyncComputed: mapState('auth', {
    async image(state) {
      if (state.profile?.image) {
        try {
          return Storage.get(state.profile.image, {level: 'protected'})
        } catch (e) {
          console.log('ERROR loading profile image, using default', e)
        }
      } else if (state.authorized?.picture) {
        try {
          return await fetch(state.authorized.picture).then(async function(response) {
            if (!response.ok) {
              console.error('ERROR loading external profile image, using default', response.error)
            }
            const blob = await response.blob()
            const result = await Storage.put('images/avatar_.png', blob,
              {level: 'protected', contentType: 'image/png'})
            await API.graphql(graphqlOperation(updateUserProfileImage,
              {input: {id: state.user.username, image: result.key}}))
            return Storage.get(result.key, {level: 'protected'})})
        } catch (e) {
          console.error('ERROR loading external profile image, using default', e)
        }
      }
      return require('@/assets/profile/anonymous-avatar.png')
    }
  }),
  methods: {
    setError(e) {
      console.error('ProfileImg TODO track and log', e)
    }
  },
}
</script>

<style scoped>

</style>
